import Navbar from "../components/navigations";
import Footer from "../components/footer";
import { useEffect, useState, useRef } from "react";
import { GetProductById } from "../services/products";
import { useShoppingCart } from "../context/ShoppingCartContext";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import { useSearchParams } from "react-router-dom";

export default function CrownAffiliateProduct() {
  const [product, setProduct] = useState({});
  const [formData, setFormData] = useState({
    promoCode: "Medspa Network Webinar",
  });
  const [errors, setErrors] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [formToDisplay, setFormToDisplay] = useState("newAccountForm");
  const formSubmitSuccess = searchParams.get("success");
  const ref = useRef(null);

  const { getItemQuantity, cartItems } = useShoppingCart();

  async function getInitialData() {
    const _id = window.location.pathname.split("/").pop();
    const product = await GetProductById(_id);
    const quantity = getItemQuantity(_id);

    setProduct({
      ...product,
      quantity: quantity,
      company: product.image.split("/")[1],
      file: product.image.split("/")[2],
      fileName: product.image.split("/")[2].split(".")[0],
    });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getInitialData();
    console.log(cartItems);
  }, [cartItems]);

  const newAccountFormItems = [
    {
      label: "Account Name (DBA)",
      name: "account",
      type: "text",
      value: formData.accountName,
    },
    {
      label: "Ship to address",
      name: "shipTo",
      type: "text",
      value: formData.shipTo,
    },
    {
      label: "Website URL",
      name: "url",
      type: "text",
      value: formData.url,
    },
    {
      label: "break",
    },
    {
      label: "Licensed Physician First Name",
      name: "firstName",
      type: "text",
      value: formData.firstName,
    },
    {
      label: "Licensed Physician Last Name",
      name: "lastName",
      type: "text",
      value: formData.lastName,
    },
    {
      label: "Licensed Physician NPI Number",
      name: "npi",
      type: "number",
      value: formData.npi,
    },
    {
      label: "Licensed Physician Email Address",
      name: "email",
      type: "email",
      value: formData.email,
    },
    {
      label: "Licensed Physician Phone Number",
      name: "phoneNumber",
      type: "number",
      value: formData.phoneNumber,
    },
    {
      label: "break",
    },
    {
      label: "Account Onboarder First Name",
      name: "managerFirstName",
      type: "text",
      value: formData.managerFirstName,
    },
    {
      label: "Account Onboarder Last Name",
      name: "managerLastName",
      type: "text",
      value: formData.managerLastName,
    },
    {
      label: "Account Onboarder Email Address",
      name: "managerEmail",
      type: "text",
      value: formData.managerEmail,
    },
    {
      label: "Account Onboarder Phone Number",
      name: "managerPhoneNumber",
      type: "number",
      value: formData.managerPhoneNumber,
    },
  ];

  const orderForm = [
    {
      label: "Account Number",
      name: "accountNumber",
      type: "text",
      value: formData.accountNumber,
    },
    {
      label: "Product",
      name: "accountName",
      type: "text",
      kind: "select",
      value: formData.accountName,
      options: [
        {
          label: "SkinPen Precision Elite System",
          details: "Pen, Charging Base, Power Supply included",
          sku: "F5SP389",
          price: 5495,
        },
        {
          label: "SkinPen Precision Elite Treatment Kit and Masque",
          details:
            "SkinPen Precision Elite Treatment Kit and Masque - 24 SkinPen Precision Elite Cartridges, 24 BioSheaths, 24 LIFT HG, 25 Pack of Patient Brochures and 24 Premium Biocellulouse Masques",
          sku: "F5SP422",
          price: 1632,
        },
        {
          label: "SkinPen Precision Elite Treatment Kit Premium 12/CASE",
          details:
            "SkinPen Precision Elite Treatment Kit Premium - 12 SkinPen Precision Elite Cartridges, 12 BioSheaths, 12 LIFT HG, 1 Box of 12 RESCUE Calming Complex, 25 Pack of Patient Brochures and 12 Premium Biocellulouse Masques.",
          sku: "F5SP421",
          price: 864,
        },
        {
          label: "SkinPen Precision Elite Treatment Kit",
          details:
            "Treatment Kit Case - 24 SkinPen Precision Elite Cartridges, 24 BioSheaths, 24 LIFT HG, 25 Pack of Patient Brochures.",
          sku: "F5SP420",
          price: 1488,
        },
      ],
    },
    {
      label: "Quantity",
      name: "quantity",
      type: "number",
      value: formData.quantity,
    },
    {
      label: "shippingAddress",
      name: "shippingAddress",
      type: "text",
      value: formData.shippingAddress,
    },
    {
      label: "billingAddress",
      name: "billingAddress",
      type: "text",
      value: formData.billingAddress,
    },
  ];

  async function handleFormSubmit(e) {
    console.log("submitting form");
    e.preventDefault();
    setDisabled(true);
    axios
      .post("/api/v2/emails/crown-signup", {
        ...formData,
      })
      .then((res) => {
        setDisabled(false);
        if (res.status === 200) {
          navigate("?success=true");
          console.log(res.status);
        }
      })
      .catch((err) => {
        console.log(err);
        setErrors(err);
      });
  }

  async function handleOrderSubmit(e) {
    console.log("submitting form");
    e.preventDefault();
    setDisabled(true);
    axios
      .post("/api/v2/emails/crown-order", {
        ...formData,
      })
      .then((res) => {
        setDisabled(false);
        if (res.status === 200) {
          navigate("?success=true");
          console.log(res.status);
        }
      })
      .catch((err) => {
        console.log(err);
        setErrors(err);
      });
  }

  return (
    <>
      <Navbar />
      <section className="lightgrey-background-section" ref={ref}>
        <div className="w-layout-blockcontainer container w-container">
          <div
            id="w-node-_54e7edc1-5170-ad65-a5dc-43245f933613-cb120944"
            className="w-layout-layout double-stack wf-layout-layout"
          >
            <div
              id="w-node-_54e7edc1-5170-ad65-a5dc-43245f933614-cb120944"
              className="w-layout-cell"
            >
              <img
                src={
                  "/content/product-images/" +
                  product.company +
                  "/resized/" +
                  product.fileName +
                  ".webp"
                }
                loading="lazy"
                alt=""
                className="product-image"
              />
            </div>
            <div
              id="w-node-_54e7edc1-5170-ad65-a5dc-43245f933615-cb120944"
              className="w-layout-cell cell-14"
            >
              <div className="header-l">{product.title}</div>
              <p className="body-s">{product.description}</p>
              <div className="header-s">
                {product.price?.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })}
              </div>

              <button
                className="button-dense-primary-dark full-width"
                type={"submit"}
                onClick={() => {
                  setFormToDisplay("newAccountForm");
                }}
              >
                I need to setup an account
              </button>

              <button
                className="button-dense-primary-dark full-width"
                type={"submit"}
                style={{ backgroundColor: "#6c917f" }}
                onClick={() => {
                  setFormToDisplay("orderForm");
                }}
              >
                I already have an Account
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="white-background-section" id={"createAccount"}>
        <div className="w-layout-blockcontainer container left-justify ">
          {searchParams.get("success") ? (
            <div
              style={{
                background: "lightgreen",
                padding: "20px 10px",
                borderRadius: 8,
                width: "100%",
              }}
            >
              <div
                className="header-l pad-top-m"
                style={{ color: "black", textAlign: "center" }}
              >
                Thank you for your interest in Crown Aesthetics!
              </div>
              <p
                className="body-m pad-top-m"
                style={{ color: "black", textAlign: "center" }}
              >
                We will be in touch with you shortly.
              </p>
            </div>
          ) : errors ? (
            <div
              style={{
                background: "lightcoral",
                padding: "20px 10px",
                borderRadius: 8,
                width: "100%",
              }}
            >
              <div
                className="header-l pad-top-m"
                style={{ color: "black", textAlign: "center" }}
              >
                Sorry there was an error submitting your form. Please refresh
                and try again.
              </div>
              <p
                className="body-m pad-top-m"
                style={{ color: "black", textAlign: "center" }}
              >
                If this problem persists, please contact us at
                <p>
                  mailto:s problem persists, pleases problem persists please
                  click the link below.
                </p>
                <a href="mailto:keaton@medspanetwork.com">
                  <p>Send Error Report</p>
                </a>
              </p>
            </div>
          ) : null}

          {formToDisplay == "newAccountForm" ? (
            <>
              <div className="header-l pad-top-m">
                New to Crown Aesthetics? Complete this form to begin your
                partnership journey.
              </div>
              <form
                style={{ width: "100%", paddingTop: "42px" }}
                onSubmit={(e) => {
                  handleFormSubmit(e);
                }}
              >
                {newAccountFormItems.map((inputField) => {
                  if (inputField.label === "break") {
                    return (
                      <div style={{ width: "100%", height: "64px" }}></div>
                    );
                  }
                  return (
                    <div className="field-group" style={{ width: "100%" }}>
                      <label className="label-s" htmlFor="accountName">
                        {inputField.label}
                      </label>
                      <input
                        className="checkout-field light"
                        style={{ width: "100%" }}
                        id={inputField.name}
                        name={inputField.name}
                        type={inputField.type}
                        required={true}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      />
                    </div>
                  );
                })}
                <button
                  disabled={disabled}
                  className="button-dense-primary-dark full-width"
                  type={"submit"}
                  style={{ maxWidth: "250px" }}
                >
                  Submit
                </button>
              </form>
            </>
          ) : (
            <>
              <div className="header-l pad-top-m">Order your products here</div>
              <form
                style={{ width: "100%", paddingTop: "42px" }}
                onSubmit={(e) => {
                  handleOrderSubmit(e);
                }}
              >
                {orderForm.map((inputField) => {
                  if (inputField.label === "break") {
                    return (
                      <div style={{ width: "100%", height: "64px" }}></div>
                    );
                  }

                  if (inputField.kind === "select") {
                    return (
                      <div className="field-group" style={{ width: "100%" }}>
                        <label className="label-s" htmlFor="accountName">
                          {inputField.label}
                        </label>
                        <select
                          className="checkout-field light"
                          style={{ width: "100%", fontSize: 16, padding: 0 }}
                          id={inputField.name}
                          name={inputField.name}
                          required={true}
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              [e.target.name]: e.target.value,
                            });
                          }}
                        >
                          {inputField.options.map((option) => {
                            return (
                              <option
                                value={option.sku}
                                style={{ fontSize: 16 }}
                              >
                                {option.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    );
                  }

                  return (
                    <div className="field-group" style={{ width: "100%" }}>
                      <label className="label-s" htmlFor="accountName">
                        {inputField.label}
                      </label>
                      <input
                        className="checkout-field light"
                        style={{ width: "100%" }}
                        id={inputField.name}
                        name={inputField.name}
                        type={inputField.type}
                        required={true}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            [e.target.name]: e.target.value,
                          });
                        }}
                      />
                    </div>
                  );
                })}
                <button
                  disabled={disabled}
                  className="button-dense-primary-dark full-width"
                  type={"submit"}
                  style={{ maxWidth: "250px" }}
                >
                  Submit
                </button>
              </form>
            </>
          )}
        </div>
      </section>
      <Footer />
    </>
  );
}
